import { Component, input, model, output } from '@angular/core';
import { CheckboxComponent } from '@cumlaude/shared-components-inputs';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-data-export-row',
	templateUrl: './data-export-row.component.html',
	styleUrls: ['./data-export-row.component.scss'],
	imports: [CheckboxComponent, IconComponent],
})
export class DataExportRowComponent {
	readonly primary = input.required<string>();

	readonly secondary = input.required<string>();

	readonly selected = model.required<boolean>();

	readonly inCategorie = input.required<boolean>();

	readonly showEditDelete = input<boolean>(false);

	readonly first = input<boolean>(false);

	editClicked = output<boolean>();

	deleteClicked = output<boolean>();
}
